import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_ERROR,
  USER_LOGOUT,
  LOGIN_VERIFY
} from "../Actions/LoginAction";

// The initial state of the login Reducer
export const initialState = {};

// reducer
const reducer = function (state = { isloggedIn: false,verify:false }, action) {
  switch (action.type) {
    case LOGIN_REQUEST:
      return { loading: true, isloggedIn: false ,verify:false};
    case LOGIN_VERIFY:
      return { loading: false, message: action.payload, isloggedIn: false ,verify:true};
    case LOGIN_SUCCESS:
      return { loading: false, ...action.payload, isloggedIn: true ,verify:false};

    case LOGIN_ERROR:
      return { loading: false, error: action.payload, isloggedIn: false ,verify:false};
    case USER_LOGOUT:
      return {};
    default:
      return state;
  }
};

export default reducer;
